import React from 'react';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import DataCard from '../_shared/DataCard';

const OnDemandPracticeReportsContainer = () => (
  <DataCard.Container direction="column">
    <DataCard.Content
      title={t('insights.on_demand_practice.users_report.title')}
      subtitle={t('insights.on_demand_practice.users_report.subtitle')}
      labsBadgeDescription={t('insights.more_reports.description')}
    >
      <a
        href={routes.INSIGHTS.ON_DEMAND_PRACTICE.USERS_REPORT}
        className="DataCard-link"
      >
        <Icon name="download" /> {t('common.download')}
      </a>
    </DataCard.Content>
    <DataCard.Content
      title={t('insights.on_demand_practice.scenarios_report.title')}
      subtitle={t('insights.on_demand_practice.scenarios_report.subtitle')}
      labsBadgeDescription={t('insights.more_reports.description')}
    >
      <a
        href={routes.INSIGHTS.ON_DEMAND_PRACTICE.SCENARIOS_REPORT}
        className="DataCard-link"
      >
        <Icon name="download" /> {t('common.download')}
      </a>
    </DataCard.Content>
  </DataCard.Container>
);

export default OnDemandPracticeReportsContainer;
